import { Theme } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

export default function IconButton(theme: Theme, containerId: string) {
  return {
    MuiIconButton: {
      defaultProps: {
        container: document.getElementById(containerId),
      },
      variants: [
        {
          props: { color: 'default' },
          style: {
            '&:hover': { backgroundColor: theme.palette.action.hover },
          },
        },
        {
          props: { color: 'inherit' },
          style: {
            '&:hover': { backgroundColor: theme.palette.action.hover },
          },
        },
      ],

      styleOverrides: {
        root: {},
      },
    },
  };
}
